<script setup lang="ts">
const props = defineProps({
	color: {
		type: String,
		default: '',
	},
	width: {
		type: String,
		default: '22',
	},
	height: {
		type: String,
		default: '22',
	},
	strokeWidth: {
		type: String,
		default: '2',
	},
});

const color = computed(() => props.color);
const { color: iconColor } = useIconColor(color);
</script>
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 22 22"
    fill="none"
  >
    <path
      d="M13.5 4.49989L15 5.99989M10.5 7.49989L12 8.99989M7.49996 10.4999L8.99996 11.9999M4.49996 13.4999L5.99996 14.9999M1.56561 16.5656L5.43424 20.4342C5.63225 20.6322 5.73125 20.7313 5.84542 20.7683C5.94584 20.801 6.05401 20.801 6.15443 20.7683C6.2686 20.7313 6.3676 20.6322 6.56561 20.4342L20.4342 6.56561C20.6322 6.3676 20.7313 6.2686 20.7683 6.15443C20.801 6.05401 20.801 5.94584 20.7683 5.84542C20.7313 5.73125 20.6322 5.63225 20.4342 5.43424L16.5656 1.56561C16.3676 1.3676 16.2686 1.2686 16.1544 1.2315C16.054 1.19887 15.9458 1.19887 15.8454 1.2315C15.7313 1.2686 15.6322 1.3676 15.4342 1.56561L1.56561 15.4342C1.3676 15.6322 1.2686 15.7313 1.2315 15.8454C1.19887 15.9458 1.19887 16.054 1.2315 16.1544C1.2686 16.2686 1.3676 16.3676 1.56561 16.5656Z"
      :stroke="iconColor"
      :stroke-width="strokeWidth"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
